import React, { useEffect, useState } from 'react';

import {
	Checkbox,
	FormControl,
	Input,
	ListItemText,
	MenuItem,
	Select,
	makeStyles,
	Button,
	Typography,
	Box,
	Divider,
	InputLabel,
	TextField,
	Menu,
	ButtonBase,
	FormLabel,
	RadioGroup,
	FormControlLabel,
	Radio
} from '@material-ui/core';
import { CheckBoxOutlineBlank, CheckBox as CheckboxIcon, ArrowDropDown } from '@material-ui/icons';
import { ReactComponent as ClassificationIcon } from '../../assets/imgs/sort-icon.svg';
import config from '../../config';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { challengeActions, curationActions } from '../../actions';



const useStyles = makeStyles((theme) => ({
	boxFormControl: {
		zIndex: 4,
		justifyContent: 'space-evenly',
		alignItems: 'center',
		minWidth: 123,
		minHeight: 56,
		backgroundColor: '#E9E9E9',
		borderRadius: 4,
		paddingRight: 10,
		paddingLeft: 10,
		marginRight: 16,
		paddingTop: 8,
		paddingBottom: 8,
	},
	filterButton: {
		color: theme.palette.neutrals.low.dark,
		backgroundColor: theme.palette.neutrals.high.light,
		'&:hover': {
			backgroundColor: theme.palette.neutrals.high.dark
		},
		fontSize: 14,
		marginLeft: 20
	},

	count: {
		margin: '8px 16px',
		padding: '4px 8px',
		backgroundColor: theme.palette.neutrals.low.lightest,
		width: 23,
		height: 24,
		fontSize: 11,
		color: theme.palette.neutrals.low.dark,
		borderRadius: 4,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},

	select: {
		minWidth: 0,
	},
	icon: {
		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},
	titleDropBox: { padding: 24, color: theme.palette.neutrals.low.light, fontSize: 14 }
}));

function ClassificationFilter() {
	const classes = useStyles();
	const [width] = useWindowSize();
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [anchorEl, setAnchorEl] = useState(null);
	const [value, setValue] = useState('ASC');

	const handleChange = ({target: {name, value}}) => {
		dispatch(curationActions.setFilters(name, value))
	};

	const handleOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (<>
		<ButtonBase
			onClick={handleOpen}
			className={classes.filterButton}
		>
			<Box width="100%" display='flex' justifyContent="space-evenly" alignItems="center">
				{width > config.RESPONSIVE_MOBILE ? (
					<>
						<ClassificationIcon width="25%" />
						<Typography width="25%">{t('classificacao')}</Typography>
					</>

				) : (<>
					<ClassificationIcon />
				</>
				)}
				<ArrowDropDown width="25%" />
			</Box>
		</ButtonBase>

		<Menu
			elevation={2}
			getContentAnchorEl={null}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}}
			anchorEl={anchorEl}
			keepMounted
			open={Boolean(anchorEl)}
			onClose={handleClose}
		>
			<Typography className={classes.titleDropBox}>{t('classificar_por')}</Typography>
			<Divider />
			<Box style={{ padding: 24, display: 'flex', flexDirection: 'column' }}>
				<FormControl>
					<RadioGroup
						aria-labelledby="demo-controlled-radio-buttons-group"
						name="controlled-radio-buttons-group"
						onChange={handleChange}
					>
						<FormControlLabel name="dateSort" value="ASC" control={<Radio />} label="Data em ordem Crescente" />
						<FormControlLabel name="dateSort" value="DESC" control={<Radio />} label="Data em ordem Decrescente" />
						<FormControlLabel name="occupationAreaSort" value="A-Z" control={<Radio />} label="Unidade de Negócio (A - Z)" />
					</RadioGroup>
				</FormControl>
			</Box>
		</Menu>
	</>);
}

export { ClassificationFilter };
